// extracted by mini-css-extract-plugin
export var btn = "Button-module--btn--MYWSk";
export var previous = "Button-module--previous--y6709";
export var primary = "Button-module--primary--uHAe9";
export var secondary = "Button-module--secondary--m8ggv";
export var secondaryviolet = "Button-module--secondaryviolet--PGxn3";
export var secondarywhite = "Button-module--secondarywhite--asg3r";
export var submit = "Button-module--submit--C5qtk";
export var tertiary = "Button-module--tertiary--obyvP";